<template>
    <div>
        <label v-if="label" class="form-label">{{ label }}:</label>
        <div class="mt-10 pb-12" :class="{ error: errors.length }">
            <input ref="file" type="file" :accept="accept" class="hidden" @change="change">
            <div class="flex justify-left mb-4">
                <icon name="disk" class="w-6 h-6" :class="{'disabled' : !isFileSelected() }"></icon>
                <span v-if="isFileSelected()" class="ml-2">{{value.name}}</span>
            </div>
            <div class="grow flex justify-left">
                <button type="button" class="btn" @click="browse" :class="{'btn-secondary' : isFileSelected(), 'btn-primary mr-5' : !isFileSelected() }">
                    {{ selectLabel }}
                </button>
                <button type="button"
                        class="ml-4 btn"
                        @click="upload"
                        :class="{
                            'disabled ' : !isFileSelected() || uploading,
                            'btn-secondary' : !isFileSelected(),
                            'btn-primary' : isFileSelected() && !uploading
                        }"
                >
                    {{ uploadLabel }}
                </button>
            </div>
        </div>
        <alert-message
            v-if="info.messages && info.messages.length > 0"
            :error-type="ERROR_TYPE_INFO"
            :messages="info.messages"
            :display-errors-title="false"
            :headline="info.headline"
            class="mb-5"
        />
        <alert-message
            v-if="errors.messages && errors.messages.length > 0"
            :error-type="ERROR_TYPE_ERROR"
            :messages="errors.messages"
            :display-errors-title="errors.displayTitle"
            :headline="errors.headline"
            class="mb-5"
        />
        <alert-message
            v-if="warnings.messages && warnings.messages.length > 0"
            :error-type="ERROR_TYPE_WARNING"
            :messages="warnings.messages"
            :display-errors-title="warnings.displayTitle"
            :headline="warnings.headline"
            class="mb-5"
        />
    </div>
</template>



<script>
import Icon from "@/Shared/Icon";
import {ErrorTypes} from '../mixins/ErrorTypes';
import AlertMessage from "@/Shared/Alerts/AlertMessage";

export default {
    components: {
        Icon,
        AlertMessage
    },
    mixins:[
        ErrorTypes
    ],
    props: {
        value: File,
        label: String,
        selectLabel: String,
        uploadLabel: String,
        accept: String,
        info: {
            messages: {
                type: Array,
                default: () => [],
            },
            headline: String,
            displayTitle: Boolean,
        },
        warnings: {
            messages: {
                type: Array,
                default: () => [],
            },
            headline: String,
            displayTitle: Boolean,
        },
        errors: {
            messages: {
                type: Array,
                default: () => [],
            },
            headline: String,
            displayTitle: Boolean,
        },
        uploading: Boolean
    },
    watch: {
        value(value) {
            if (!value) {
                this.$refs.file.value = ''
            }
        }
    },
    methods: {
        filesize(size) {
            var i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
        },
        browse() {
            this.$refs.file.click()
        },
        change(e) {
            this.$emit('input', e.target.files[0])
        },
        remove() {
            this.$emit('input', null)
        },
        upload() {
            if(this.isFileSelected()){
                this.$emit('upload', null)
            }
        },
        isFileSelected(){
            return this.value && this.value.name && this.value.name.length > 0 > 0;
        }
    },
}
</script>
